import { Button, Modal } from '@pm/ui';
import { useTranslation } from 'react-i18next';

type BackButtonModalProps = {
  showConfirmationModal: boolean;
  handleState: () => void;
  handleClose: () => void;
  handleConfirm: () => void;
  /** What confirming does next — differs between the questionnaire flow and the immediate one. */
  text: string;
};

export const BackButtonModal = ({
  showConfirmationModal,
  handleState,
  handleClose,
  handleConfirm,
  text,
}: BackButtonModalProps) => {
  const { t } = useTranslation(['global', 'treatments']);

  return (
    <Modal.Root open={showConfirmationModal} onOpenChange={handleState}>
      <Modal.Content
        title={t('treatments:PrepTreatment.Confirmation.Title')}
        aria-label="Confirm change of treatment plan"
      >
        <Modal.Body>{text}</Modal.Body>
        <Modal.Actions>
          <Button
            intent="secondary"
            width="full"
            aria-label="No"
            onClick={handleClose}
          >
            {t('global:No')}
          </Button>
          <Button width="full" aria-label="Yes" onClick={handleConfirm}>
            {t('global:Yes')}
          </Button>
        </Modal.Actions>
      </Modal.Content>
    </Modal.Root>
  );
};
